import { get, put, upload, post, del } from '@api/request';

export async function fetchAllRollCorrGroups(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroups`;
  let { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRollCorrGroup(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateRollCorrGroup(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId, payload },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteRollCorrGroup(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function deleteRollCorrFromGroup(
  { appraisalService },
  authenticationToken,
  { pYear, pRollCorr },
) {
  const url = `${appraisalService}/appraisal/rollcorrection/${pYear}/${pRollCorr}/delete`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function recalculateRollCorrGroup(
  { appraisalService },
  authenticationToken,
  { rollCorrectionGroupID },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrectionGroupID}/recalculate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function recalculateRollCorrGroupStatus(
  { recalculationService },
  authenticationToken,
  { recalcID },
) {
  const url = `${recalculationService}/recalc/job/${recalcID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function lockRollCorrGroup(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}/lock`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function unlockRollCorrGroup(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}/unlock`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function tempOpenRollCorrGroup(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}/tempopen`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function finalizeRollCorrGroup(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}/finalize`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function unfinalizeRollCorrGroup(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}/unfinalize`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export const uploadFile = async (
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId, payload },
) => {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteFile = async (
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId, s3Id, lastUpdate },
) => {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}/file/${s3Id}`;
  const { body } = await put(authenticationToken, url, { lastUpdate });
  return body;
};

export const updateFile = async (
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId, payload },
) => {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadFile = async (
  { appraisalService },
  authenticationToken,
  { rollCorrGroupId, s3Id },
) => {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupId}/file/${s3Id}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function exportRollCorrGroup(
  { exportService },
  authenticationToken,
  { rollCorrGroupId, payload },
) {
  const url = `${exportService}/export/rollcorrectiongroupexport/${rollCorrGroupId}/export`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchRollCorrGroupExportStatus(
  { exportService },
  authenticationToken,
  { rollCorrGroupId },
) {
  const url = `${exportService}/export/rollcorrectiongroupexport/${rollCorrGroupId}/export`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTotalRuns(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/totals`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchGroupProperties(
  { appraisalService },
  authenticationToken,
  { year, pRollCorr },
) {
  const url = `${appraisalService}/appraisal/rollcorrection/${year}/${pRollCorr}/propertylisting`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createTaxLimitationCalculationRun(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/calculationruns`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchTaxLimitationCalculationRuns(
  { appraisalNoticeService },
  authenticationToken,
  { rollCorrGroupId },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/calculationruns?rollCorrGroupID=${rollCorrGroupId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxLimitationCalculationRunProperties(
  { appraisalNoticeService },
  authenticationToken,
  { runID, page, pageSize, excluded },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/calculationrun/${runID}/properties?errorFilter=Exclude%20Errors&page=${page}&pageSize=${pageSize}${
    excluded ? '&filter=Differences%20Only' : ''
  }`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxLimitationCalculationRunErrors(
  { appraisalNoticeService },
  authenticationToken,
  { runID, page, pageSize },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/calculationrun/${runID}/properties?errorFilter=Errors%20Only&page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchGroupRecaptures(
  { appraisalNoticeService },
  authenticationToken,
  { rollCorrGroupId },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/rollcorrectiongroup/${rollCorrGroupId}/verification`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createGroupRecaptures(
  { appraisalNoticeService },
  authenticationToken,
  { rollCorrGroupId, payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/rollcorrectiongroup/${rollCorrGroupId}/verification`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchGroupRecaptureErrors(
  { appraisalNoticeService },
  authenticationToken,
  { runID, page, pageSize },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/verification/${runID}/errors?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchGroupRecaptureFreezes(
  { appraisalNoticeService },
  authenticationToken,
  { runID, page, pageSize },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/verification/${runID}/freezes?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function undoGroupRecapture(
  { appraisalNoticeService },
  authenticationToken,
  { runID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/verification/${runID}/undo`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function createRollCorrGroup(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroupcreatewithyears`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMassRollCorrectionJobs(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/massrollcorrectjobs`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassRollCorrectionJobDetail(
  { appraisalService },
  authenticationToken,
  { runID },
) {
  const url = `${appraisalService}/appraisal/massrollcorrectjob/${runID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createMassRollCorrectionJob(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/massrollcorrectjobs`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function massRollCorrJobValidateQuery(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/massrollcorrectjob/validatequery`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMassRollCorrectionJobErrors(
  { appraisalService },
  authenticationToken,
  { runID, page, pageSize },
) {
  const url = `${appraisalService}/appraisal/massrollcorrectjob/${runID}/errors?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassRollCorrectionJobProperties(
  { appraisalService },
  authenticationToken,
  { runID, page, pageSize },
) {
  const url = `${appraisalService}/appraisal/massrollcorrectjob/${runID}/properties?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassRollCorrectionJobProcessed(
  { appraisalService },
  authenticationToken,
  { runID, page, pageSize },
) {
  const url = `${appraisalService}/appraisal/massrollcorrectjob/${runID}/processed?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRollCorrAvailableYears(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/rollcorrection/availableyears`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRollCorrMoveOpenAppealHistory(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupID },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupID}/moveopenappealshistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRollCorrOpenAppeals(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupID },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupID}/openappeals`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function moveRollCorrOpenAppeals(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupID, payload },
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollCorrGroupID}/moveopenappeals`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchRollCorrOpenGroups(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/rollcorrectiongroups/open`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRollCorrOpenGroupErrors(
  { appraisalService },
  authenticationToken,
  { rollCorrGroupID, page, pageSize },
) {
  const url = `${appraisalService}/recalc/recalcerrorsforrollcorrgroup/${rollCorrGroupID}?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}
